import {put,takeLatest} from 'redux-saga/effects';
import {
    CLEAR_SEARCH_RESULTS,
    CLEAR_SEARCH_RESULTS_SUCCESS,
    CLEAR_SEARCH_RESULTS_ERROR
}
    from "../../actions/searchresults";

function* clearSearchResultsSaga() {
    try {
        yield put({
            type: CLEAR_SEARCH_RESULTS_SUCCESS,
            payload: []
        });

    } catch(error) {
        yield put({
            type: CLEAR_SEARCH_RESULTS_ERROR,error: error.data ? error.data : error
        });
    }
}


export function* clearSearchResultsSagaWatcher() {
    yield takeLatest(CLEAR_SEARCH_RESULTS,clearSearchResultsSaga);
}